import { createContext } from 'react'

export const ClientContext = createContext()

export default function ClientContextProvider({ children, config, shop }) {
  return <ClientContext.Provider value={{ config, shop }}>{children}</ClientContext.Provider>
}
